import { render, staticRenderFns } from "./TeamsList.vue?vue&type=template&id=264d50e9&scoped=true&"
import script from "./TeamsList.vue?vue&type=script&lang=js&"
export * from "./TeamsList.vue?vue&type=script&lang=js&"
import style0 from "./TeamsList.vue?vue&type=style&index=0&id=264d50e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d50e9",
  null
  
)

export default component.exports